import { useTheme } from "@mui/material";
import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const Formats: React.FC<SvgIconProps> = (props) => {
  const theme = useTheme();

  return (
    <SvgIcon {...props} viewBox="0 0 18 19" fill="none">
      <svg
        width="18"
        height="19"
        viewBox="0 0 18 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 17.1827C7.32914 17.1827 5.72671 16.5236 4.54523 15.3503C3.36375 14.1771 2.7 12.5858 2.7 10.9265C2.7 9.26727 3.36375 7.67598 4.54523 6.50272C5.72671 5.32945 7.32914 4.67031 9 4.67031C10.6709 4.67031 12.2733 5.32945 13.4548 6.50272C14.6363 7.67598 15.3 9.26727 15.3 10.9265C15.3 12.5858 14.6363 14.1771 13.4548 15.3503C12.2733 16.5236 10.6709 17.1827 9 17.1827ZM9 2.88283C6.85175 2.88283 4.79148 3.73028 3.27243 5.23877C1.75339 6.74725 0.9 8.7932 0.9 10.9265C0.9 13.0598 1.75339 15.1058 3.27243 16.6143C4.79148 18.1228 6.85175 18.9702 9 18.9702C11.1483 18.9702 13.2085 18.1228 14.7276 16.6143C16.2466 15.1058 17.1 13.0598 17.1 10.9265C17.1 8.7932 16.2466 6.74725 14.7276 5.23877C13.2085 3.73028 11.1483 2.88283 9 2.88283ZM9.45 6.4578H8.1V11.8203L12.375 14.3674L13.05 13.2681L9.45 11.15V6.4578ZM5.292 2.33764L4.14 0.970215L0 4.41113L1.161 5.77856L5.292 2.33764ZM18 4.42007L13.86 0.970215L12.699 2.33764L16.839 5.78749L18 4.42007Z"
          fill={theme.palette.brandedTypography.textColor}
        />
      </svg>
      ;
    </SvgIcon>
  );
};

export default Formats;
